var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcPencil(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m-168.2-328 3.7-14.9 22.7-22.7 11.2 11.2-22.7 22.7-14.9 3.7zm6.3-13.5-2.4 9.6 9.6-2.4 20.2-20.2-7.2-7.2-20.2 20.2z",
    transform: "translate(179 382)",
    fill: "#ffd700",
    className: "fill-134563"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-155.7-332.6c-1-3.9-4-6.9-7.9-7.9l.7-2.8c4.9 1.2 8.7 5 9.9 9.9l-2.7.8",
    transform: "translate(179 382)",
    fill: "#ffd700",
    className: "fill-134563"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m-156-338.1-2-2.1 19.9-19.9 2 2-19.9 20M-166.2-330l4.4-1.1c-.4-1.6-1.7-2.9-3.3-3.3l-1.1 4.4M-129.5-355.5l-11.2-11.2 4.5-4.5.7.1c5.4.7 9.7 5 10.4 10.4l.1.7-4.5 4.5zm-7.1-11.2 7.2 7.2 1.4-1.4c-.8-3.6-3.6-6.4-7.2-7.2l-1.4 1.4z",
    transform: "translate(179 382)",
    fill: "#ffd700",
    className: "fill-134563"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPencil);
export default __webpack_public_path__ + "static/media/ic_pencil.96a8873e44a81bd9be4d5a9e14ae6b3c.svg";
export { ForwardRef as ReactComponent };